import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import BookmarkButton from './BookmarkButton';

/**
 * PromptCard Component - Reusable card for displaying prompt information
 */
const PromptCard = ({ prompt, showBookmark = true }) => {
  const navigate = useNavigate();
  const { currentUser } = useAuth();

  if (!prompt) {
    return null;
  }

  return (
    <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-md hover:shadow-xl transition card-hover relative h-full flex flex-col">
      <div
        onClick={() => navigate(`/prompts/${prompt.id}`)}
        className="cursor-pointer flex-grow"
      >
        <h3 className="text-xl font-semibold mb-2 line-clamp-2 text-gray-900 dark:text-white">
          {prompt.title}
        </h3>
        <p className="text-gray-600 dark:text-gray-400 mb-4 line-clamp-3">
          {prompt.description}
        </p>
        <div className="flex items-center justify-between text-sm mb-3">
          <span className="text-gray-500 dark:text-gray-400">
            by @{prompt.username || 'Anonymous'}
          </span>
          <span className="text-boop-primary font-semibold">
            ⭐ {(parseFloat(prompt.bayesian_rating) || 0).toFixed(1)}
          </span>
        </div>
        <div className="flex gap-2 flex-wrap">
          {prompt.tags?.slice(0, 3).map((tag, i) => (
            <span
              key={i}
              className="px-2 py-1 bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 text-xs rounded-full"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>

      {/* Bookmark Button */}
      {showBookmark && currentUser && (
        <div className="mt-4 pt-4 border-t border-gray-200 dark:border-gray-700 flex justify-end">
          <BookmarkButton
            promptId={prompt.id}
            className="w-auto"
          />
        </div>
      )}
    </div>
  );
};

export default PromptCard;
